import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ControlPanel, ControlPanelItem, RouteLink } from '@sumtotal/react-foundation';
import styled from 'styled-components';
import useCustomNavigation from '../../hooks/useCustomNavigation';
import { postMessage } from '../../../modules/core/services/coreIFrameHelper';
import { GetProcessedNodeUrl } from '../../../utils/urlHelper';
import useHeaderContext from '../../hooks/useHeaderContext';
import useUserContext from '../../hooks/useUserContext';
import getNotificationCount from '../../topnav/services/timelineService';
import { getPastDueCount } from '../../../modules/onePlace/activitiesAndTasks/activities/services/myActivitiesService';

import getLogger from '../../../utils/logger';

const StyledControlPanelItem = styled(ControlPanelItem)`
  background-color: ${(props) => {
    if (
      props.highlightControlPanelItem &&
      (props.navigatioUrl === '' ||
        (props.navigatioUrl === '/' &&
          window.location.pathname === `/rcore${props.homePageUrl.split('?')[0]}`) ||
        window.location.pathname === `/rcore${props.navigatioUrl.split('?')[0]}`)
    )
      return props.theme.variables.topbarNavActiveStateBackground;
    return 'inherit';
  }};
  color: ${(props) => {
    if (
      props.highlightControlPanelItem &&
      (props.navigatioUrl === '' ||
        (props.navigatioUrl === '/' &&
          window.location.pathname === `/rcore${props.homePageUrl.split('?')[0]}`) ||
        window.location.pathname === `/rcore${props.navigatioUrl.split('?')[0]}`)
    )
      return props.theme.variables.topbarNavActiveStateTextColor;
    return props.theme.variables.leftNavParentColor;
  }};
  &:focus {
    background-color: ${(props) => {
      if (
        props.highlightControlPanelItem &&
        (props.navigatioUrl === '' ||
          (props.navigatioUrl === '/' &&
            window.location.pathname === `/rcore${props.homePageUrl.split('?')[0]}`) ||
          window.location.pathname === `/rcore${props.navigatioUrl.split('?')[0]}`)
      )
        return props.theme.variables.topbarNavActiveStateBackground;
      return props.theme.variables.topbarNavHoverStateBackground;
    }};
  }
`;

const StyledControlPanel = styled(ControlPanel)`
  min-height: ${(props) => props.minh}px;
  display: flex;
  flex-direction: column;
  .MuiButton-outlined.Mui-disabled {
    border: none;
  }
`;

const StyledRouteLink = styled(RouteLink)`
  bottom: 0.75rem;
  width: inherit;
  margin-top: 0.75rem;
  text-align: center;
  text-transform: none;
  font-size: 0.625rem;
  line-height: 0.75rem;
  text-decoration: none;
  font-weight: 500;
  padding: 0.0625rem;
  color: ${(props) => props.theme.variables.leftNavParentColor};
  &:focus,
  &:hover,
  &:active {
    text-decoration: underline;
  }
`;

const EllipseControlPanelItem = styled(ControlPanelItem)`
  padding-top: 0rem;
  padding-bottom: 0rem;
  min-height: 1.25rem;
`;

const DisabledLink = styled(StyledRouteLink)`
  pointer-events: none;
`;
/**
 *  Component for Control Panel Container.
 *
 */
function ControlPanelContainer({
  controlPanelItems,
  highlightControlPanelItem,
  setHighlightCPItem
}) {
  const { t } = useTranslation(['TRANSLATIONS_RCORE_TOPNAV']);
  const navigate = useCustomNavigation();
  const [ControlPanelItemList, setControlPanelItemList] = useState([]);
  const [PageControlPanelItemList, setPageControlPanelItemList] = useState([]);
  const [ControlPanelFooter, setControlPanelFooter] = useState({});
  const nodes = controlPanelItems.Nodes;
  const footerNode = controlPanelItems.Footer;
  const headerData = useHeaderContext();
  const { headerContext, setHeaderContext } = headerData;
  const [timelineCount, setTimelineCount] = useState();
  const [mytodosOverDueCount, setMytodosOverDueCount] = useState();
  const { user } = useUserContext();
  const disableControlPanel = user.isEmulatedUser ? false : user.mustAnswerSecurityQuestions;
  const Link = disableControlPanel ? DisabledLink : StyledRouteLink;
  const [showUpperEllipse, setShowUpperEllipse] = useState(false);
  const [showLowerEllipse, setShowLowerEllipse] = useState(false);
  const [calcHeight, updateCalcHeight] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [firstPage, setFirstpage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [minHeight, setMinHeight] = useState(null);
  const logger = getLogger();

  const updateSize = () => {
    const clientheight = document.getElementById('modal-sidebar-controlpanel-items').clientHeight;
    updateCalcHeight(clientheight);
    if (clientheight > 220) {
      const first = Math.round((clientheight - 142) / 58);
      if (first >= ControlPanelItemList.length) {
        setCurrentPage(1);
        setShowLowerEllipse(false);
        setShowUpperEllipse(false);
        setFirstpage(ControlPanelItemList.length);
        setPageControlPanelItemList(ControlPanelItemList);
      } else {
        setFirstpage(first);
        setLastPage(ControlPanelItemList.length - first);
        if (currentPage === 2) {
          setPageControlPanelItemList(
            ControlPanelItemList.slice(
              ControlPanelItemList.length - lastPage,
              ControlPanelItemList.length
            )
          );
          setShowLowerEllipse(false);
          setShowUpperEllipse(true);
          const minh = 150 + (ControlPanelItemList.length - first) * 58;
          setMinHeight(minh);
        } else if (currentPage === 1) {
          setShowLowerEllipse(true);
          setShowUpperEllipse(false);
          setPageControlPanelItemList(ControlPanelItemList.slice(0, first));
          setMinHeight(null);
        }
      }
    }
  };

  function ChangeEllipsePosition(position) {
    if (position) {
      setShowUpperEllipse(false);
      setShowLowerEllipse(true);
      setPageControlPanelItemList(ControlPanelItemList.slice(0, firstPage));
      setCurrentPage(1);
      setMinHeight(null);
      setTimeout(() => {
        document.getElementById('sidebar-lower-ellipsis').focus();
      }, 200);
    } else if (!position) {
      setShowUpperEllipse(true);
      setShowLowerEllipse(false);
      setPageControlPanelItemList(
        ControlPanelItemList.slice(
          ControlPanelItemList.length - lastPage,
          ControlPanelItemList.length
        )
      );
      setCurrentPage(2);
      const minh = 150 + lastPage * 58;
      setMinHeight(minh);
      setTimeout(() => {
        document.getElementById('sidebar-upper-ellipsis').focus();
      }, 200);
    }
  }

  const timeLineBadgeAriaLable = useCallback((Count) => {
    if (Count > 1) {
      return t('RCORE_TOPNAV_TIMELINE_ITEMS', {
        Count
      });
    }
    return t('RCORE_TOPNAV_TIMELINE_ITEM', {
      Count
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Data required for Control Panel
    const ControlPanelData = [];
    if (nodes != null) {
      nodes.forEach((item) => {
        const node = item;
        if (node.nodeKey === 'home_header') {
          node.url = '/';
        } else if (
          node.nodeKey === 'alert_header' &&
          (headerContext.refreshTimeline === undefined || headerContext.refreshTimeline)
        ) {
          const forceRefresh =
            headerContext.refreshTimeline === undefined ? false : headerContext.refreshTimeline;
          getNotificationCount(null, forceRefresh, true)
            .then((Count) => {
              if (Count > 0) {
                node.showBadgeIcon = true;
                node.ariaLabel = timeLineBadgeAriaLable(Count);
              } else {
                node.showBadgeIcon = false;
              }
              setTimelineCount(Count);
              postMessage(
                'REFRESH_TIMELINE_COUNT',
                { notificationCount: Count },
                false,
                null,
                false,
                true
              );
              if (headerContext.refreshTimeline) {
                setHeaderContext((state) => ({
                  ...state,
                  refreshTimeline: false
                }));
              }
              return Count;
            })
            .catch((err) => {
              logger.error(err);
              return 0;
            });
        } else if (node.nodeKey === 'my_activities') {
          const getMyTodosOverDueCount = async () => {
            try {
              const { data } = await getPastDueCount({});
              if (data) {
                const { pastDueTrainingCount } = data[0];
                if (pastDueTrainingCount) {
                  node.showBadgeIcon = true;
                  node.ariaLabel = timeLineBadgeAriaLable(pastDueTrainingCount);
                  setMytodosOverDueCount(pastDueTrainingCount);
                } else {
                  node.showBadgeIcon = false;
                  node.ariaLabel = timeLineBadgeAriaLable(pastDueTrainingCount);
                  setMytodosOverDueCount(pastDueTrainingCount);
                }
              }
            } catch (error) {
              logger.error(error);
            }
          };
          getMyTodosOverDueCount();
        }
        ControlPanelData.push(node);
      });
    }
    setControlPanelItemList(ControlPanelData);
    setPageControlPanelItemList(ControlPanelData);
    setFirstpage(ControlPanelData.length);
    if (footerNode != null) {
      footerNode.url = GetProcessedNodeUrl(footerNode);
    }
    setControlPanelFooter(footerNode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nodes, footerNode, headerContext.refreshTimeline, setHeaderContext, timeLineBadgeAriaLable]);

  useEffect(() => {
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calcHeight, ControlPanelItemList]);

  function handleItemClick(event, nodeKey, action) {
    setHighlightCPItem(nodeKey);
    if (action === 'OPEN_LIBRARY') {
      if (window.location.pathname.indexOf('/c/') > 0) {
        postMessage(action, null, null, event.currentTarget.id);
        return;
      }
      const libNode = ControlPanelItemList.find((item) => item.nodeKey === 'Learner_MenuTaxonomy');
      navigate(libNode.url);
    } else if (action !== 'NAVIGATE') {
      postMessage(action, null, null, event.currentTarget.id);
    } else return null;
  }

  function handleItemMouseClick(event, nodeKey, action, url) {
    if (
      action === 'NAVIGATE' &&
      (event.keyCode === 13 || event.button === 1 || event.button === 0)
    ) {
      setHighlightCPItem(nodeKey);
      navigate(url);
    }
  }

  const getBadgeCount = ({ nodeKey }) => {
    if (nodeKey === 'alert_header') return timelineCount;
    if (nodeKey === 'my_activities') return mytodosOverDueCount;
    return null;
  };
  return (
    <StyledControlPanel
      id="modal-sidebar-controlpanel-items"
      role="navigation"
      ariaLabel={t('RCORE_TOPNAV_CONTROLPANEL_REGION')}
      className="side-bar no-print"
      width={5.625}
      footer={
        ControlPanelFooter != null ? (
          <Link to={ControlPanelFooter.url}>{ControlPanelFooter.name}</Link>
        ) : null
      }
      minh={minHeight}
    >
      <div id="modal-sidebar-backdrop" className="modal-backdrop sidebar-backdrop" />
      {showUpperEllipse && (
        <EllipseControlPanelItem
          id="sidebar-upper-ellipsis"
          isDisabled={disableControlPanel}
          iconType="MaterialIcon"
          iconName="MoreHoriz"
          iconSize={1.75}
          ariaLabel={t('RCORE_SIDENAV_SHOW_PRIMARY_ARIA_LABEL')}
          onItemClick={() => ChangeEllipsePosition(true)}
        />
      )}
      {PageControlPanelItemList &&
        PageControlPanelItemList.map((item) => (
          <StyledControlPanelItem
            isDisabled={disableControlPanel}
            key={item.nodeKey}
            iconType={item.iconType}
            iconName={item.iconName}
            iconSize={1.75}
            btnSize="large"
            name={item.name}
            navigatioUrl={item.actionType === 'NAVIGATE' ? item.url : ''}
            role={item.actionType === 'NAVIGATE' ? 'link' : 'button'}
            actionType={item.actionType}
            onItemClick={item.actionType !== 'NAVIGATE' ? handleItemClick : undefined}
            onKeyDown={item.actionType === 'NAVIGATE' ? handleItemMouseClick : undefined}
            onMouseDown={item.actionType === 'NAVIGATE' ? handleItemMouseClick : undefined}
            showBadgeIcon={item.showBadgeIcon}
            notificationCount={getBadgeCount(item)}
            ariaLabel={item.ariaLabel}
            nodeKey={item.nodeKey}
            highlightControlPanelItem={item.nodeKey === highlightControlPanelItem}
            homePageUrl={user.homePageUrl}
          />
        ))}

      {showLowerEllipse && (
        <EllipseControlPanelItem
          id="sidebar-lower-ellipsis"
          isDisabled={disableControlPanel}
          iconType="MaterialIcon"
          iconName="MoreHoriz"
          iconSize={1.75}
          ariaLabel={t('RCORE_SIDENAV_SHOW_OTHER_ARIA_LABEL')}
          onItemClick={() => ChangeEllipsePosition(false)}
        />
      )}
    </StyledControlPanel>
  );
}
// PropType check
ControlPanelContainer.propTypes = {
  /**
   * Control panel items
   */
  controlPanelItems: PropTypes.shape({
    Nodes: PropTypes.arrayOf(PropTypes.shape({})),
    Footer: PropTypes.shape({ url: PropTypes.string })
  }),
  /**
   * Highlight Control panel item
   */
  highlightControlPanelItem: PropTypes.string,
  /**
   * function highlight Control panel item
   */
  setHighlightCPItem: PropTypes.func
};

ControlPanelContainer.defaultProps = {
  controlPanelItems: {},
  highlightControlPanelItem: '',
  setHighlightCPItem: undefined
};

export default ControlPanelContainer;
